import {
  Empty,
  ConstructionBarrierIcon,
  EmptyHeadline,
  EmptyDescription,
} from '@frontend/components';

export const UnderConstruction = ({
  children,
}: React.PropsWithChildren<unknown>) => {
  return (
    <Empty margin="auto">
      <ConstructionBarrierIcon />
      <EmptyHeadline>Under Construction</EmptyHeadline>
      <EmptyDescription>{children}</EmptyDescription>
    </Empty>
  );
};
